import PricePlanCalculatorSettings from 'client/components/core/Sidebar/components/Settings/entities/PricePlanCalculatorSettings'
import createCommonEntitySettings from 'client/pages/createCommonEntitySettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import React from 'react'

const createSettingsForWebsitePricing = (entity: EntityInterface) => {
  switch (entity.type) {
    case EntityTypeEnum.PricePlanCalculator:
      return (
        <PricePlanCalculatorSettings
          entity={entity as PricePlanCalculatorInterface}
        />
      )

    default:
      return createCommonEntitySettings(entity)
  }
}

export default createSettingsForWebsitePricing
